<div class="py-4">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center py-2">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <form [formGroup]="taskForm">
            <mat-form-field class="half-width" appearance="outline">
                <mat-label>Priorytet:</mat-label>
                <mat-select formControlName="priority" [(value)]="selectedTask">
                    <mat-option value="normalny">normalny</mat-option>
                    <mat-option value="wysoki">wysoki</mat-option>
                    <mat-option value="niski">niski</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="pt-2">
                <mat-form-field class="full-width pt-2" appearance="outline">
                    <mat-label>Nazwa:</mat-label>
                    <input matInput formControlName="name" name="name" type="text"
                           placeholder="Nazwa"
                           #nameLength>
                    <mat-hint align="end">
                        {{ nameLength.value.length }} / {{ nameMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="taskName.errors?.['required']">
                        Podaj nazwę zadania.
                    </mat-error>
                    <mat-error
                        *ngIf="taskName.value.length < nameMinLength && !taskName.errors?.['required']">
                        Minimalna długość wynosi {{ nameMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="taskName.value.length > nameMaxLength">
                        Maksymalna długość wynosi {{ nameMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pt-2">
                <mat-form-field class="full-width pt-2" appearance="outline">
                    <mat-label>Opis:</mat-label>
                    <textarea matInput formControlName="description" name="description" type="text"
                              placeholder="Opis" #descriptionLength></textarea>
                    <mat-hint align="end">
                        {{ descriptionLength.value.length }} / {{ descriptionMaxLength }}
                    </mat-hint>
                    <mat-error
                        *ngIf="taskDescription.value.length < descriptionMinLength && !taskDescription.errors?.['required']">
                        Minimalna długość wynosi {{ descriptionMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="taskDescription.value.length > descriptionMaxLength">
                        Maksymalna długość wynosi {{ descriptionMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <div class="pt-2">
            <mat-slide-toggle [(ngModel)]="isDeadline" (click)="setCurrentDateTime()"> Zadanie w
                terminie: {{ isDeadline ? 'tak' : 'nie' }}
            </mat-slide-toggle>
        </div>
        <div *ngIf="isDeadline" class="pt-4">
            <mat-form-field appearance="outline" color="primary">
                <mat-label>Termin wykonania na:</mat-label>
                <input matInput [matDatepicker]="deadlinePicker" [formControl]="deadlineDate">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="deadlinePicker"></mat-datepicker-toggle>
                <mat-datepicker #deadlinePicker (closed)="setTaskDeadlineDate()"></mat-datepicker>
            </mat-form-field>
        </div>
    </ng-template>
</div>
